import React, { useState } from 'react';
import './WhatsAppFloat.css';

const opciones = [
  {
    id: 'general',
    etiqueta: 'Información General',
    mensaje: 'Hola, me interesa conocer más sobre sus servicios de pesaje industrial',
  },
  {
    id: 'cotizacion',
    etiqueta: 'Solicitar Cotización',
    mensaje: 'Hola, necesito una cotización para servicios de calibración',
  },
  {
    id: 'soporte',
    etiqueta: 'Soporte Urgente',
    mensaje: 'Hola, necesito soporte técnico urgente',
  },
];

const IconoWhatsApp = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.28-1.38a9.9 9.9 0 0 0 4.71 1.2h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.13-2.9-7C17.18 3.03 14.69 2 12.04 2Zm0 18.13h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.13.82.84-3.05-.2-.31a8.22 8.22 0 0 1-1.26-4.39c0-4.55 3.7-8.25 8.26-8.25 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.84c0 4.55-3.71 8.25-8.25 8.25Zm4.52-6.18c-.25-.12-1.47-.72-1.69-.81-.23-.08-.4-.12-.56.13-.17.25-.64.81-.78.97-.15.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.15.16-.25.24-.41.08-.17.04-.31-.02-.44-.06-.12-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.43-.14-.01-.31-.01-.48-.01-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.02 2.6.12.17 1.78 2.71 4.3 3.81.6.26 1.07.42 1.44.53.6.19 1.15.16 1.58.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.16-.48-.28Z" />
  </svg>
);

const WhatsAppFloat = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleWhatsAppClick = (mensaje) => {
    const whatsappUrl = `https://wa.me/+56976234326?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    setIsExpanded(false);
  };

  return (
    <div className={`whatsapp-float ${isExpanded ? 'is-open' : ''}`}>
      {isExpanded && (
        <div className="whatsapp-options">
          <p className="whatsapp-options-titulo">¿En qué podemos ayudarte?</p>
          {opciones.map((opcion, index) => (
            <button
              key={opcion.id}
              className="whatsapp-option"
              style={{ '--delay': `${index * 0.05}s` }}
              onClick={() => handleWhatsAppClick(opcion.mensaje)}
            >
              {opcion.etiqueta}
            </button>
          ))}
        </div>
      )}

      <button
        className="whatsapp-button"
        onClick={toggleExpanded}
        aria-label={isExpanded ? 'Cerrar opciones de WhatsApp' : 'Contactar por WhatsApp'}
        aria-expanded={isExpanded}
      >
        <span className="whatsapp-ring" aria-hidden="true"></span>
        <span className="whatsapp-icon">
          <IconoWhatsApp />
        </span>
      </button>
    </div>
  );
};

export default WhatsAppFloat;
